import './ReferralNoteBox.scss'

import React from 'react'
import moment from 'moment-timezone'
import {
  ASSIGNMENT_AGENT_STATUS,
  ASSIGNMENT_AGENT_STATUS_LISTING,
  ASSIGNMENT_AGENT_STATUS_LEASE,
} from 'common/constants'
import { labelFor } from 'common/util/helper'

const getLabelset = ({ is_lease, transaction_type }) => {
  if (is_lease) {
    return ASSIGNMENT_AGENT_STATUS_LEASE
  }
  if (transaction_type === 'list') {
    return ASSIGNMENT_AGENT_STATUS_LISTING
  }
  return ASSIGNMENT_AGENT_STATUS
}

export const ReferralNoteBox = ({ referral, key, created_at, agent_note, transaction_status }) => {
  return (
    <div className="ReferralNoteBox" key={key}>
      <div className="top-date">{ moment.utc(created_at).local().format("M/DD/YY") }</div>
      <div className="note">{ agent_note }</div>
      <div className="bottom-row">
        <div className="stage-change">
          <div>{ labelFor(getLabelset(referral), transaction_status) }</div>
        </div>
        <div className="date">{ moment.utc(created_at).local().format("ddd, MMM Do YYYY h:mm A") }</div>
      </div>
    </div>
  )
}
